export const accountants = '/accountants';
export const accountant = (id: number) => `/accountants/${id}`;
export const download = '/accountants/download';
